import React from "react";
import { useParams } from "react-router-dom";
import { EncounterWorkspace } from "@/components/encounter/SymptomIntakeCard";

export default function EncounterDetail() {
  const { id } = useParams();
  return <EncounterWorkspace encounterId={id} />;
}
